import { FC } from "react";
import { ResourceExplorerCostsDateDetails } from "@/services/cloudchipr.api";
import { TrendChip } from "@/components/common/chips/TrendChip";
import { BillingExplorerWidgetNoDataCell } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/cells/BillingExplorerWidgetNoDataCell";

interface BillingExplorerWidgetPrevCostCellProps {
  trend?: number | null;
  dates?: ResourceExplorerCostsDateDetails;
}

export const BillingExplorerWidgetTrendCell: FC<
  BillingExplorerWidgetPrevCostCellProps
> = ({ trend, dates }) => {
  if (trend === null) {
    return <BillingExplorerWidgetNoDataCell dates={dates} />;
  }

  return <TrendChip value={trend} />;
};
